module Client.Logger

open Fable.Core
open Fable.Core.JsInterop
open Browser

type SeverityLevel =
  | Verbose = 0
  | Information = 1
  | Warning = 2
  | Error = 3
  | Critical = 4

// module AppInsights =
//   [<Emit("window['$']($0)")>]
//   let select (selector: string) = jsNative

[<Emit("appInsights")>]
let appInsights : obj = jsNative

// https://github.com/Microsoft/ApplicationInsights-JS/blob/master/API-reference.md

let trackEvent (name : string) (value : obj) = appInsights?trackEvent({| name = name |}, value)
let trackException (ex : System.Exception) = appInsights?trackException ex
let trackPageView () = appInsights?trackPageView()
let trackPageViewWithDetails (details : obj) = appInsights?trackPageView {| properties = details |}
let log (severityLevel : SeverityLevel) message = window?appInsights?trackTrace {| message = message; severityLevel = severityLevel |}
let logVerbose message = log SeverityLevel.Verbose message
let logInformation message = log SeverityLevel.Information message
let logWarning message = log SeverityLevel.Warning message
let logError message = log SeverityLevel.Error message
let logCritical message = log SeverityLevel.Critical message